import { styled } from '@mui/material'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  .highcharts-xaxis-labels{
    & text:first-of-type, & text:last-of-type{
      opacity: 1;
    }
  }
`

export const Exportable = styled('div')``
